import { LazyProductGridMobileSlot } from './ProductGridMobileSlot';
import { LazyProductGridDesktopSlot } from './ProductGridDesktopSlot';

export const ProductGridSlot = {
  desktop: LazyProductGridDesktopSlot,
  mobile: LazyProductGridMobileSlot,
};

export type { ProductGridProps } from './ProductGridDesktopSlot';
